<template>
    <div>
        <el-dialog title="高拍仪拍照" :visible.sync="showFile" width="900px" :append-to-body="true" :before-close="handleClose">
            <!-- 高拍仪视频预览区 -->
            <div id="myactive">
                <span>图片质量:</span> <el-select id="view1_mode" v-model="altimeterData.quality">
                    <el-option label="默认质量" value="0"></el-option>
                    <el-option label="高质量" value="1"></el-option>
                    <el-option label="较高质量" value="2"></el-option>
                    <el-option label="中质量" value="3"></el-option>
                    <el-option label="较低质量" value="4"></el-option>
                    <el-option label="低质量" value="5"></el-option>
                </el-select>
                <span>色彩模式:</span><el-select size="mini" inline v-model="altimeterData.ColorMode">
                    <el-option label="白纸印章" value="3"></el-option>
                    <el-option label="彩色" value="0"></el-option>
                    <!-- <el-option label="灰色" value="1"></el-option> -->
                    <el-option label="黑白" value="2"></el-option>
                    <!-- <el-option label="去背景色(普通文件)" value="4"></el-option> -->
                    <!-- <el-option label="去背景色(身份证)" value="5"></el-option> -->
                </el-select>
                <!-- <br> -->

                <!-- <el-button style="margin-left:10px"  @click="rotate(90)" type="primary" size="mini">左转</el-button>
                        <el-button style="margin-left:10px"  @click="rotate(270)" type="primary" size="mini">右转</el-button> -->
                <el-button style="margin-left:10px" @click="rotate(90)" type="primary" size="mini" icon="el-icon-refresh-left" circle></el-button>
                <el-button style="margin-left:10px" @click="rotate(270)" type="primary" size="mini" icon="el-icon-refresh-right" circle></el-button>

                <span style="margin-left:10px">剪切值:</span>
                <el-input-number style="margin-left:10px" v-model="altimeterData.deskewval" size="mini"></el-input-number>
                <span style="margin-left:10px">图片剪切:</span>
                <el-switch style="margin-left:10px" @change="delBlackBoard" v-model="switchValue" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>
                <!-- <el-button style="margin-left:10px" @click="view1_scan" type="primary" size="mini">拍照</el-button> -->
            </div>
            <div style="display: flex; justify-content: flex-end;">
                <el-button style="margin-left:10px" @click="view1_scan" type="primary" size="mini">兼容拍照</el-button>
                <el-button style="margin-left:10px" @click="view2_scan" type="primary" size="mini">拍照</el-button>
            </div>
            <div class="view-warp">
                <div id="view">
                    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头">
                </div>
                <!-- 缩略图 -->
                <div id="suoluetu">
                    <!-- <div v-for="item in img_base64List" :key="item">
                        <img :src="item">
                    </div> -->
                    <div v-for="(item, index) in img_base64List" :key="item" class="imgList">
                        <!-- <img :src="item"> -->
                        <el-image style="width: 100px; height: 100px;margin-bottom: 5px;" :src="item" :preview-src-list="img_base64List">
                        </el-image>
                        <el-button type="danger" @click="delImgList(index)" size="mini">删除</el-button>
                    </div>

                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="isshowFile">取 消</el-button>
                <el-button type="primary" @click="congirmGpyFile">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import axios from 'axios'
import {
    upFile,
} from "@/service/printApi.js";
export default {

    name: 'FileNewAction',
    // props:['formData'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
        showFile: {
            type: Boolean,
            default: false
        },
        scanFlag: {
            type: Boolean,
            default: false
        },
        // 上传类型标识，随上传接口参数一起提交
        uploadType: {
            type: String,
            default: ''
        },
    },
    data() {
        //这里存放数据
        return {
            token: { token: sessionStorage.getItem('token') },
            fileList: [], //文件
            requesUrl: "",
            imgUrl: "",
            formData: {},
            LicensetypeList: [],//证照列表
            view1_resolution_list: [],
            img_base64List: [],
            view1_resolution_selected: '',
            NewelectFileIds: [],
            gpyNum: 0,
            altimeterData: {
                "filepath": "base64",
                "rotate": "0",
                "cutpage": "0",
                "camidx": "0",
                "ColorMode": "3",
                "quality": "1",
                "deskew": "1",
                "deskewval": 50

            },
            switchValue: false,
            arrImgList: [],
            indexA: 0,
            showBox: true,
            headers: {
                "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
                "Access-Token": "Access-Token123456",//自定义请求头
                "Content-Type": "application/json;charset=utf8"
            },
        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {

        //
        delBlackBoard(e) {
            let openFun = 0
            if (e == true) {
                openFun = 1
            }
            console.log(this.switchValue, e)
            this.getStatus(openFun)
        },
        //删除列表图片
        delImgList(index) {
            this.img_base64List.splice(index, 1)
        },
        //去黑边

        getStatus(e) {
            axios.post("http://127.0.0.1:38088/video=status").then((res) => {
                console.log(res)
                if (res.data.code == 0) {
                    setTimeout(() => {
                        let data = { "camidx": '0', "open": String(e) }
                        axios.post("http://127.0.0.1:38088/dvideo=cameradeskew", JSON.stringify(data)).then((res) => {
                        })
                    }, 500)
                }
            })
        },

        isshowFile() {

            this.$emit('isshowFile', false)
        },
        // 是否确认关闭
        handleClose(done) {
            this.$confirm("关闭弹窗将删除已选择的范围，确认关闭？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.isshowFile()
                })
                .catch(() => { });
        },
        // 高拍仪提交方法
        congirmGpyFile() {
            this.arrImgList = []
            this.indexA = 0
            var token = sessionStorage.getItem("token");
            var list = []
            this.img_base64List.forEach(async (key, i) => {
                var arr = key.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                var timestamp = (new Date()).valueOf()
                const formData = new FormData()
                var fileliu = new File([u8arr], timestamp + '.jpg', { type: mime })
                if (this.scanFlag) {
                    list.push(fileliu)
                } else {
                    formData.append('file', fileliu)
                    if (this.uploadType) {
                        formData.append('type', this.uploadType)
                    }
                    this.arrImgList.push([formData])
                }
            })
            if (this.scanFlag) {
                this.$emit('NewelectFileIds', list)
            } else {
                this.imgUpLoad()
            }
        },

        async imgUpLoad() {
            console.log(this.indexA)
            var token = sessionStorage.getItem("token");
            await upFile(this.arrImgList[0][0], token).then((res) => {
                if (res.status == 200) {
                    this.arrImgList.shift()
                    this.indexA = Number(this.indexA) + Number(1)
                    this.NewelectFileIds.push(res.result[0])
                    if (this.arrImgList.length > 0) {
                        this.imgUpLoad()
                        return
                    } else {
                        this.NewelectFileIds.forEach(item => {
                            this.$set(item, 'url', `${window.global_config.BASE_IMG_URL}/${item.fileUrl}`)
                        })
                        console.log(this.NewelectFileIds, "NewelectFileIds");
                        this.$emit('NewelectFileIds', this.NewelectFileIds)
                        return
                    }
                }

                // if (i == this.img_base64List.length - 1) {

            })

        },

        // 旋转
        rotate(angle) {
            let data = { "camidx": '0', "rotate": String(angle) }
            axios.post("http://127.0.0.1:38088/video=rotate", JSON.stringify(data), this.headers).then((res) => {
            })
        },

        // 切换主摄像头视频模式，重新加载主摄像头分辨率
        view1_mode_change(val) {
            let data = { "camidx": '0', "mode": val }
            axios.post("http://127.0.0.1:38088/device=getresolution", JSON.stringify(data)).then((res) => {
                let resolution_list = res.data.data.split("|");
                view1_resolution_selected = resolution_list[0]
                this.view1_resolution_list = []
                for (var i = 0; i < resolution_list.length; i++) {
                    this.view1_resolution_list.push(resolution_list[i])
                }
            })
        },

        // 主头拍照
        view1_scan() {
            let data = JSON.parse(JSON.stringify(this.altimeterData))
            delete data.deskewval
            delete data.deskew
            axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(data), { headers: this.headers }).then((res) => {
                console.log(res)
                this.add_image(res.data.photoBase64)
            })
        },
        view2_scan() {
            axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(this.altimeterData), { headers: this.headers }).then((res) => {
                console.log(res)
                this.add_image(res.data.photoBase64)
            })
        },
        add_image(img_base64) {
            if (this.img_base64List.length >= 1) {
                // this.img_base64List = this.img_base64List.splice(1, 1)
                this.img_base64List.push("data:image/jpg;base64," + img_base64)
            } else {
                this.img_base64List.push("data:image/jpg;base64," + img_base64)
            }
        },
        initVidio() {
            // 加载主摄像头视频模式
            let view1_mode_data1 = { "camidx": "0", "mode": "0" };
            let view1_mode_data2 = { "camidx": "0", "mode": "1" };
            axios.post("http://127.0.0.1:38088/device=getresolution", JSON.stringify(view1_mode_data2)).then((res) => {
                if (res.data.data.split("|").length > 1) {
                    let data = new Object()
                    data.key = '1'
                    data.value = 'MJPG'
                    this.view1_mode_list.push(data)
                }
            })
            // axios.post("http://127.0.0.1:38088/device=getresolution", JSON.stringify(view1_mode_data1)).then((res)=>{
            //   if(res.data.data.split("|").length > 1){
            //     let data = new Object()
            //     data.key = '0'
            //     data.value = 'YUY2'
            //     this.view1_mode_list.push(data)
            //   }
            // })
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

        // this.initVidio()
        // this.getStatus()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.img_base64List = []
        this.NewelectFileIds = []
        setTimeout(() => {
            this.switchValue = true
            this.getStatus(1)
        }, 100)
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.view-warp {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
}

/* 全局 */
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 10px;
}

/* 视频预览 */
#view1,
#view2 {
    width: 400px;
    height: 300px;
    border: 1px solid #000;
    margin-right: 5px;
}

/* 缩略图 */
#suoluetu {
    width: 460px;
    display: flex;
    flex-wrap: wrap;
    height: 300px;
    overflow-y: auto;
}

#suoluetu .imgList {
    width: 100px;
    height: 140px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    margin: 5px;
}

/* 操作按钮 */
#myactive {
    /* border: 1px solid yellowgreen; */
    margin-top: 10px;
    padding: 10px 5px;
}

/* 操作日志 */
#mylog {
    border: 1px solid black;
    padding: 10px;
    margin-top: 10px;
    overflow: auto;
}
</style>
<style scoped>
.el-select {
    width: 150px !important;
}
</style>